import React, { useEffect } from 'react';
import { observer } from 'mobx-react';

import { ButtonWithDropdown, Icon } from 'components';
import { RulerIcon } from 'icons';
import { themes } from 'styles/themes/wikifactoryNew';
import { analytics } from 'core/analytics';
import { renderCustomIcon } from 'utils/jsxUtils';
import { UiModes } from 'libs/rendering/gltf/config';
import { CADPanelType } from 'constants/cad';
import { useCADManager } from 'hooks';
import {
  EyeWrapper,
  OperatorWrapper,
  CADButtonWrapper,
} from './CADButtonWrapper';

const measureId = 'CADPage-measureButton';

export const MeasureButton = observer(() => {
  const { viewerControl, toggleMeasurePanel, itemMeasurements, itemId } = useCADManager();

  // Fix click Measure icon show other panel bug.
  useEffect(() => {
    viewerControl.UpdateUiMode(UiModes.collapsed);
  }, []);

  const { viewer } = viewerControl;

  const { engine, module, settings, sectionManager, selectionManager } =
    viewer || {};

  const measureCount = itemMeasurements.get(itemId).length;

  const selMode = selectionManager?.GetSelectionMode();
  const selModeEnum = module?.SelectionMode;

  const isActiveRuler =
    viewerControl.uiMode === UiModes.measurements ||
    viewerControl.toolBarExpanded === 'measurement' ||
    viewerControl.activePanelType === CADPanelType.MeasurementPanel;

  const isDisabledRuler =
    sectionManager?.IsRunning?.() || engine?.ExplodeRuning?.();

  // ANNOTATIONS
  const toggleMeasurementsVisibility = () => {
    if (settings.measureVisible) {
      // hiding measurments, stop adding more
      viewerControl.Escape();
    }
    settings.measureVisible = !settings.measureVisible;

    const eventAction = settings.measureVisible ? 'hide' : 'show';
    analytics.sendEvent(`viewer-measurements-${eventAction}`);
  };

  const isMeasuring = selMode === selModeEnum?.SelectionModeMeasurements;
  const showMeasureEyes = !!measureCount;

  return (
    <CADButtonWrapper id={measureId} isActive={isActiveRuler}>
      <OperatorWrapper
        isActive={isActiveRuler}
        className={`${showMeasureEyes ? '' : 'rounded'}`}
      >
        <ButtonWithDropdown
          renderIcon={isHover =>
            renderCustomIcon(RulerIcon, {
              isHover,
              isActive: isActiveRuler,
              activeFillColor: themes.color.wfBlue,
            })
          }
          tooltip={isMeasuring ? 'Finish measuring' : 'Measurements'}
          data-testid='CADPage-annotationIcon'
          onClick={toggleMeasurePanel}
          isActive={isActiveRuler}
          hasDropdown={false}
          borderRight='none'
          style={{
            borderRadius: '50%',
          }}
          dropdownDirection='right'
          isDisabled={isDisabledRuler}
        />
      </OperatorWrapper>
      {showMeasureEyes && (
        <EyeWrapper
          onClick={toggleMeasurementsVisibility}
          className=' hover:rounded-br hover:rounded-bl'
        >
          <Icon
            size='default'
            name={settings.measureVisible ? 'view_off' : 'view'}
          />
        </EyeWrapper>
      )}
    </CADButtonWrapper>
  );
});
